import { useSelector } from 'react-redux';

import Global from '../../store/global-selectors';

/** @typedef {import('../../constants/features-type.d.ts').FeatureCode} FeatureCode */

/**
 * @param {FeatureCode} featureCode
 * @returns {boolean}
 */
export const useIsAlphaUser = (featureCode) => {
  const subscriptionData = useSelector(Global.selectSellerSubscriptionData);
  const { currentBillingPlan } = subscriptionData ?? {};
  const currentSubscriptionLineItems = currentBillingPlan?.subscriptionLineItems ?? [];
  const lineItem = currentSubscriptionLineItems.find((x) => x?.featureIds?.includes(featureCode)) ?? {};
  const isAlphaUser = lineItem.isAlphaUser ?? false;
  return isAlphaUser;
};
